export default __webpack_public_path__ + "static/media/hydration.ae5122f9.svg";